/**
 * Galería de juegos imprimibles de Baby Shower Dulce Recuerdo.
 * Para cambiar una página, reemplazá la URL de `src`.
 * Si `src` queda vacío, se muestra un placeholder identificado.
 */
export const babyShowerGames = [{
  title: 'Bingo Baby Shower',
  src: 'https://cdn.magicpatterns.com/uploads/vLKoeoLdfHuKhcpyThHp1A/Baby_Shower_Dulce_Recuerdo_NENA_compressed-9_page-0001.jpg'
}, {
  title: '¿Quién conoce más a mamá?',
  src: 'https://cdn.magicpatterns.com/uploads/oxRs3LcVWNW3KyAVHUCs9T/Baby_Shower_Dulce_Recuerdo_NENE_compressed-5_page-0001.jpg'
}, {
  title: 'Predecí al bebé',
  src: 'https://cdn.magicpatterns.com/uploads/rCAoGuSvcERwGU4a7drWcV/Baby_Shower_Dulce_Recuerdo_NENA_compressed-20_page-0001.jpg'
}, {
  title: 'Diseñá el body',
  src: 'https://cdn.magicpatterns.com/uploads/bir8FRtukxYoUHEjHiiHrg/Baby_Shower_Dulce_Recuerdo_NENE_compressed-34_page-0001.jpg'
}, {
  title: '+50 dinámicas',
  src: 'https://cdn.magicpatterns.com/uploads/pzLC38vNVBKmFMPrQgekES/Baby_Shower_50_Juegos_Movimiento_NENA_compressed-7_page-0001.jpg'
}, {
  title: 'Sopa de letras',
  src: 'https://cdn.magicpatterns.com/uploads/mGhaGCKjNqjEbWUi5TNaeq/Baby_Shower_50_Juegos_Movimiento_NENE_compressed-48_page-0001.jpg'
}, {
  title: 'Ruleta',
  src: 'https://cdn.magicpatterns.com/uploads/tCYaGDAopfTTxZbCwvNCMH/Baby_Shower_Dulce_Recuerdo_NENA_compressed-87_page-0001.jpg'
}, {
  title: "Trivia Famosos y más!",
  src: 'https://cdn.magicpatterns.com/uploads/3W1NUx1qrVQTe7n6vYAAwy/Baby_Shower_Dulce_Recuerdo_NENE_compressed-47_page-0001.jpg'
}];